import React from "react";

const ItemsReview = () => {
  return <div>This is item review</div>;
};

export default ItemsReview;
